import { type ErrorHandler, Injectable, inject } from '@angular/core';

import { LoggerService } from '../logging/logger.service';
import { ToastService } from '../toast/toast.service';
import { ApiError } from './api-error';
import { ErrorMessageService } from './error-message.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  private readonly logger = inject(LoggerService);
  private readonly messages = inject(ErrorMessageService);
  private readonly toasts = inject(ToastService);

  handleError(error: unknown): void {
    const unwrapped = unwrap(error);

    this.logger.error('Unhandled error', unwrapped);

    this.toasts.error(this.messages.toUserMessage(unwrapped));
  }
}

function unwrap(error: unknown): unknown {
  if (error instanceof Error && 'cause' in error && ApiError.isApiError(error.cause)) {
    return error.cause;
  }

  return error;
}
